export const objectTypes = [
  { type: 'contracts', name: 'Договоры' },
  { type: 'acts', name: 'Акты' },
  { type: 'payments', name: 'Платежи' },
  { type: 'law_cases', name: 'Судебные дела' },
  { type: 'procedures', name: 'Запросы материалов' },
  { type: 'bank_guarantee_versions', name: 'Банковские гарантии' }
]
